import { MantineThemeOverride } from '@mantine/core';

import colorsConfig from '@mygpt/app/theme/colors';

const { breakpoints, colors, fontFamily, fontFamilyMonospace } = colorsConfig;

type ColorKeys = keyof Omit<typeof colors, 'white' | 'black'>;

// eslint-disable-next-line @typescript-eslint/ban-types
type CustomColors = ColorKeys | (string & {});

declare module '@mantine/core' {
  export interface MantineThemeColorsOverride {
    colors: Record<CustomColors, string[]>;
  }

  export interface MantineThemeOther {
    mobileView: boolean;
  }
}

const mantineColors = Object.fromEntries(
  Object.entries(colors)
    .filter(([k, v]) => typeof v !== 'string')
    .map(([k, v]) => [k, Object.values(v)])
) as Record<CustomColors, string[]>;

export const themeConfig: MantineThemeOverride = {
  colors: mantineColors,
  breakpoints: {
    xs: breakpoints.sm,
    sm: breakpoints.md,
    md: breakpoints.lg,
    lg: breakpoints.xl,
    xl: breakpoints['2xl'],
  },
  fontFamily,
  fontFamilyMonospace,
  cursorType: 'pointer',
  other: {
    mobileView: false,
  },
};
